import React, {useState} from 'react';
import t from '../../../helpers/t';
import { facilitySlotActions, facilityActions } from "inbooma-api";              // necessary to communicate with inbooma-react api
import { Biscuit } from '../../../../utils';
import { rbac } from '../index';

const SlotsView = (props) => {
    const { facility, dispatch, showStatus, onRemoveSlot, onOpenDoor, onOpenSlot, onShowTrackings, onShowSlotHistories } = props;
    const getChargingLabel = (value) => {

        if (value == 7) return t("full");
        if (value < 7 && value > 3) return t("half_full");
        if (value <= 3) return t("empty");
    };

    const statusSelectHandle = (e,index) => {

        dispatch(facilitySlotActions.editFacilitySlot({
            id: Number(facility.facility_slots[index].id),
            body: {
                ...facility.facility_slots[index],
                status: e.target.value,
                all_roles: true
            },
            token: Biscuit.get('token')
        }));
        setTimeout(function () {
            dispatch(facilityActions.getFacilities({
                token: Biscuit.get('token')
            }))
        },200);
        
        // change slot.status, facility.facility_slots
    };

    return (
        <div id={"slots-panel-" + props.facility.id} className="inb-c-item-details inb-c-contingent-resources row" style={{height:'max-content'}}>
            {(facility.facility_type === 'general_paketin_pin' || facility.facility_type === 'general_paketin_admin' && facility.booking_type === 'contingent')?
                <>
                    <header className="inb-c-item-details__header small-12 column">
                        <a href={"facilities/"+facility.id+"/add?path=/facilities&item="+facility.id}
                           className="inb-c-item-add inb-resource-manage small button beautify float-right"
                           data-inb-facility-id={facility.id}
                           data-inb-action-link="write"> {t('add_${a}',{a:t('box')})}  </a>
                        <span className="inb-list-title">{t('boxes')}</span>
                    </header>
                </>
                    :<> <header className="inb-c-item-details__header small-12 column">
                    {facility.facility_slots.length == 0 && <>
                        <a href={"facilities/"+facility.id+"/add?path=/facilities&item="+facility.id}
                           className="inb-c-item-add inb-resource-manage small button beautify float-right"
                           data-inb-facility-id={facility.id}
                           data-inb-action-link="write"> {t('add_${a}',{a:t('slot')})}  </a>
                        <span className="inb-list-title">{t('no_linked_slots')}</span></>
                    }
                    {facility.facility_slots.length > 0 && <>
                        <a href={"facilities/"+facility.id+"/add?path=/facilities&item="+facility.id}
                           className="inb-c-item-add inb-resource-manage small button beautify float-right"
                           data-inb-facility-id={facility.id}
                           data-inb-action-link="write"> {t('add_${a}',{a:t('slot')})}  </a>
                        <span className="inb-list-title">{t('linked_slots') + " " + facility.facility_slots.length}</span></>
                    }
                        </header>
                    </>
                }

            {facility.facility_slots.map((slot,index) => {
                if(facility.facility_type === 'general_paketin_pin'){
                    return (
                        <div className="inb-resource inb-c-item-details-row row" key={slot.id}>
                            <div
                                className="medium-3 column inb-facilty_slot__facility_slot_name">{slot.resource.name}</div>
                            <div className="medium-2 column inb-facilty_slot__external_resource_id"
                                 title={t('external_resource_id')}>{slot.external_resource_id}</div>
                            <div className="medium-3">&nbsp;</div>
                                <div className="medium-3 column text-right">
                                    <div className="row">
                                        <div className="medium-2 small-3 column">
                                    <a href={"/reservations/reservationsList?resource_id=" +slot.resource_id}
                                        title={t('orders',null,'capital')}><i className="fi fi-page"></i></a>
                                        </div>
                                        {rbac.hasPermission('openDoor') && <div className="medium-2 small-3 column">
                                            <a className="inb-resource__status inb-c-item__status" href="#" onClick={() => showStatus(slot)}
                                       title={t('status')}><i className="fi fi-list"></i></a>
                                        </div>}
                                        {rbac.hasPermission('openDoor') && <div className="medium-2 small-3 column">
                                            <a className="inb-resource__open_door inb-c-item__open_door" href="#" onClick={() => onOpenDoor('slot',slot)}
                                               title={t('open')}><i className="fi fi-key"></i></a>
                                        </div>}
                                        {rbac.hasPermission('editFacility') && <>
                                            <div className="medium-2 small-3 column">
                                                <a className="inb-resource__edit inb-c-item__edit" href={"/facilities/"+slot.facility_id+"/"+slot.id}
                                                   title={t('edit_${a}', {a: t('slot')})}><i className="fi fi-wrench"></i></a>
                                            </div>
                                            <div className="medium-2 small-3 column">
                                            <a className="inb-resource__remove inb-c-item__remove" href="#" onClick={() => onRemoveSlot(slot)}
                                       title={t('delete_${a}', {a: t('slot')})}><i className="fi fi-trash"></i></a>
                                        </div></>}
                                    </div>
                                </div>
                        </div>
                    );
                } else {
                    if(facility.facility_type === 'general_paketin_admin' && facility.booking_type === 'contingent') {
                        return (
                            <div className="inb-resource inb-c-item-details-row row" key={slot.id}>
                                <div
                                    className="medium-3 column inb-facilty_slot__facility_slot_name">{slot.resource.name}</div>
                                <div className="medium-3 column inb-facilty_slot__external_resource_id"
                                     title={t('external_resource_id')}>{slot.external_resource_id}</div>
                                <div className="medium-3">&nbsp;</div>

                                    <div className="medium-3 column text-right">
                                        <div className="row">
                                            <div className="medium-2 small-3 column">
                                                <a href={"/reservations/reservationsList?resource_id=" + slot.resource_id}
                                                   title={t('orders', null, 'capital')}><i
                                                    className="fi fi-page"></i></a>
                                            </div>
                                            {rbac.hasPermission('openDoor') &&<><div className="medium-2 small-3 column">
                                                <a className="inb-resource__status inb-c-item__status" href="#"
                                                   onClick={ () => onShowTrackings(slot, 'facilitySlot')}
                                                   title={t('show trackings')}><i className="fi fi-list"></i></a>
                                            </div>
                                            <div className="medium-2 small-3 column">
                                                <a className="inb-resource__open_door inb-c-item__open_door" href="#"
                                                   onClick={() => onOpenDoor('slot', slot)}
                                                   title={t('open')}><i className="fi fi-key"></i></a>
                                            </div></>}
                                            {rbac.hasPermission('editFacility') &&<>
                                                <div className="medium-2 small-3 column">
                                                    <a className="inb-resource__edit inb-c-item__edit" href={"/facilities/"+slot.facility_id+"/"+slot.id}
                                                       title={t('edit_${a}', {a: t('box')})}><i className="fi fi-wrench"></i></a>
                                                </div>
                                            <div className="medium-2 small-3 column">
                                                <a className="inb-resource__remove inb-c-item__remove" href="#"
                                                   onClick={() => onRemoveSlot(slot)}
                                                   title={t('delete_${a}', {a: t('box')})}><i
                                                    className="fi fi-trash"></i></a>
                                            </div></>}
                                        </div>
                                    </div>

                            </div>
                        );
                    } else {
                        return (
                            <div className="inb-resource inb-c-item-details-row row" key={slot.id}>
                                <div
                                    className="medium-1 column inb-facilty_slot__facility_slot_nbr">#{slot.facility_slot_nbr}</div>
                                <div className="medium-1 column inb-facilty_slot__external_resource_id"
                                     title={t('external_resource_id')}>{(slot.external_resource_id === null?"":slot.external_resource_id + " "+slot?.resource?.name+ " ("+slot?.resource?.resource_nbr+")")}</div>
                                {slot.charging_state != null && slot.charging_state != '' &&
                                    <div className="medium-1 column inb-facilty_slot__charging_state"
                                         title={t('battery_condition') + ': ' + getChargingLabel(slot.charging_state)}>
                                        {slot.charging_state == 7 &&
                                            <i className="fi fi-battery-full battery--full"></i>}
                                        {slot.charging_state < 7 && slot.charging_state > 3 &&
                                            <i className="fi fi-battery-half battery--half"></i>}
                                        {slot.charging_state <= 3 &&
                                            <i className="fi fi-battery-half battery--empty"></i>}
                                    </div>
                                }
                                {(false && (typeof slot.charging_state === 'undefined' || slot.charging_state == null || slot.charging_state == '')) &&
                                    <div className="medium-1 column"></div>
                                }
                                {false && typeof slot.charging_quality !== 'undefined' && slot.charging_quality != null && slot.charging_quality != '' &&
                                    <div className="medium-1 column inb-facilty_slot__charging_quality"
                                         title={t('charging_quality')}>
                                        {slot.charging_quality}%
                                    </div>
                                }
                                {(typeof slot.charging_state === 'undefined' || slot.charging_state == null || slot.charging_state == '') &&
                                    <div className="medium-1 column"></div>
                                }
                                <div className="medium-1 column inb-facilty_slot__lock_open"
                                     title={(slot.lock_open ? t('open') : t('closed'))}>
                                    {slot.lock_open &&
                                        <i className="fi fi-unlock lock--open"></i>
                                    }
                                    {!slot.lock_open &&
                                        <i className="fi fi-lock lock--closed"></i>
                                    }
                                </div>
                                <div className="medium-2 column inb-facilty_slot__error_text"
                                     title={t('error_text') + slot.error_text}></div>

                                <div className="medium-1 column inb-facilty_slot__error_code"
                                     title={t('error_code') + slot.error_code}></div>

                                <div className="medium-2 small-7 medium-offset-0 column">
                                    <div className="inb-status-select inb-before-badge">
                                        <select className="inb-status-select" value={slot.status}
                                                onChange={(e) => statusSelectHandle(e, index)}
                                                disabled={!rbac.hasPermission('editFacility')}>
                                            <option value="active">{t('active')}</option>
                                            <option value="inactive">{t('inactive')}</option>
                                        </select>
                                    </div>
                                </div>
                                {rbac.hasPermission('editFacility') &&<>
                                    <div className="medium-1 small-3 column text-right">
                                        <a className="inb-resource__edit inb-c-item__edit" href={"/facilities/"+slot.facility_id+"/"+slot.id}
                                           title={t('edit_${a}', {a: t('slot')})}><i className="fi fi-wrench"></i></a>
                                        {rbac.hasPermission('openDoor')  &&
                                            <>
                                                <a className="inb-resource__status inb-c-item__status" href="#" style={{paddingLeft:"20%"}}
                                                   onClick={ () => onShowSlotHistories(slot, 'facilitySlot')}
                                                   title={t('show trackings')}><i className="fi fi-list"></i></a>

                                            <a className="inb-resource__open_door inb-c-item__open_door" href="#" onClick={() => onOpenSlot(slot)} style={{width:"40px",display:"inline-block"}}
                                               title={t('open')}><i className="fi fi-key"></i></a></>}
                                    </div>
                                    <div className="medium-1 small-3 column">
                                        <a className="inb-resource__remove inb-c-item__remove" href="#"
                                           onClick={() => onRemoveSlot(slot)}
                                           title={t('delete_${a}', {a: t('slot')})}><i
                                            className="fi fi-trash"></i></a>
                                    </div></>}
                            </div>
                        );
                    }
                }
                })

            }
        </div>
    );
};


export default SlotsView;